import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { getAgeRoleplayIdByTitle } from '@/pages/Onboarding/options/AgeRoleplay/utils/getAgeRoleplayIdByTitle';
import { getBodyShapeIdByTitle } from '@/pages/Onboarding/options/BodyShape/utils/getBodyShapeIdByTitle';
import { getOutfitStyleIdByTitle } from '@/pages/Onboarding/options/OutfitStyle/utils/getOutfitStyleIdByTitle';
import { preloadImage } from '@/utils/preloadImage';

import { LayoutDataType } from '../types';

export const useRoleplayRoomGirlImage = (paywall: boolean = false): string => {
  const { user } = useAccount();
  const form = useFormContext<LayoutDataType>();

  const ageUserData = getAgeRoleplayIdByTitle(user?.onboarding_data?.age);
  const bodyShapeUserData = getBodyShapeIdByTitle(
    user?.onboarding_data?.body_shape,
  );
  const outfitStyleUserData = getOutfitStyleIdByTitle(
    user?.onboarding_data?.outfitStyle,
  );

  const age = form?.watch('age') || ageUserData;
  const bodyShape = form?.watch('body_shape') || bodyShapeUserData;
  const outfitStyle = form?.watch('outfit_style') || outfitStyleUserData;

  const character = age === 'experienced' ? 'lucy' : 'kellie';

  const selectedBodyShape = bodyShape || 'regular';
  const selectedOutfitStyle = outfitStyle || 'latex_seductress';

  const paywallPath = `${S3_BUCKET_URL}/paywall/fast-pay-tab/own_ai_roleplay_rooms/${character}_${selectedOutfitStyle}_${selectedBodyShape}.png`;
  const regularPath = `${S3_BUCKET_URL}/own-ai-roleplay-rooms/name/${character}_${selectedOutfitStyle}_${selectedBodyShape}.png`;

  preloadImage(paywallPath);
  preloadImage(regularPath);

  return paywall ? paywallPath : regularPath;
};
